import { Observable } from 'rxjs';
import { ChangeCandidateDto } from 'src/app/data-transfer/entities/change-candidate-dto';
import { ImportCandidateDto } from 'src/app/data-transfer/entities/import-candidate-dto';

export enum ImportTypeSetting {
  Import,
  ChangeTracking,
}

export interface PackagingImportHelper {
  getTableTitle(importType: ImportTypeSetting, archiveActive: boolean): string;
  getDisplayedColumns(): string[];
  getPackagingImportCandidates(): Observable<ImportCandidateDto[]>;
  getPackagingChangeCandidates(): Observable<ChangeCandidateDto[]>;
  packagingImportCandidatesSeen(): Promise<any>;
  packagingChangeCandidatesSeen(): Promise<any>;
  packagingImportCandidatesCountUpdate(): Promise<any>;
  packagingChangeCandidatesCountUpdate(): Promise<any>;
  getDeleteFunction(importType: ImportTypeSetting): (candidate: number) => Observable<any>;
  getImportFunctionImportCandidate(): (candidateId: number, targetDirId: number, isWithTracking: boolean) => Observable<any>;
  getChangeFunctionChangeCandidate(): (changeId: number) => Observable<any>;
  getPackagingIdsFromChangeCandidates(selectedChanges: ChangeCandidateDto[]): number[];
  navigateToCandidate(candidate: ImportCandidateDto): void;
  navigateToChange(candidate: ChangeCandidateDto, seePackagingBeforeChange: boolean): void;
}
